var _defineProperty = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/defineProperty.js").default;

var _objectSpread = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/objectSpread2.js").default;

var _toConsumableArray = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;

!function webpackUniversalModuleDefinition(e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["@wordpress/notices"] = t() : (e.wp = e.wp || {}, e.wp.notices = t());
}(self, function () {
  return function () {
    var e = {
      424: function _(e) {
        e.exports = function _interopRequireDefault(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }, e.exports.__esModule = !0, e.exports.default = e.exports;
      },
      535: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.createErrorNotice = function createErrorNotice(e, t) {
          return createNotice("error", e, t);
        }, t.createInfoNotice = function createInfoNotice(e, t) {
          return createNotice("info", e, t);
        }, t.createNotice = createNotice, t.createSuccessNotice = function createSuccessNotice(e, t) {
          return createNotice("success", e, t);
        }, t.createWarningNotice = function createWarningNotice(e, t) {
          return createNotice("warning", e, t);
        }, t.removeNotice = function removeNotice(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : i.DEFAULT_CONTEXT;
          return {
            type: "REMOVE_NOTICE",
            id: e,
            context: t
          };
        };
        var o = r(793),
            i = r(987);

        function createNotice() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : i.DEFAULT_STATUS,
              t = arguments.length > 1 ? arguments[1] : void 0,
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          var _r$speak = r.speak,
              n = _r$speak === void 0 ? !0 : _r$speak,
              _r$isDismissible = r.isDismissible,
              c = _r$isDismissible === void 0 ? !0 : _r$isDismissible,
              _r$context = r.context,
              u = _r$context === void 0 ? i.DEFAULT_CONTEXT : _r$context,
              _r$id = r.id,
              s = _r$id === void 0 ? (0, o.uniqueId)(u) : _r$id,
              _r$actions = r.actions,
              a = _r$actions === void 0 ? [] : _r$actions,
              _r$type = r.type,
              d = _r$type === void 0 ? "default" : _r$type,
              l = r.__unstableHTML,
              _r$icon = r.icon,
              f = _r$icon === void 0 ? null : _r$icon,
              _r$explicitDismiss = r.explicitDismiss,
              p = _r$explicitDismiss === void 0 ? !1 : _r$explicitDismiss,
              _ = r.onDismiss;
          return t = String(t), {
            type: "CREATE_NOTICE",
            context: u,
            notice: {
              id: s,
              status: e,
              content: t,
              spokenMessage: n ? t : null,
              __unstableHTML: l,
              isDismissible: c,
              actions: a,
              type: d,
              icon: f,
              explicitDismiss: p,
              onDismiss: _
            }
          };
        }
      },
      987: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.DEFAULT_STATUS = t.DEFAULT_CONTEXT = void 0;
        t.DEFAULT_CONTEXT = "global";
        t.DEFAULT_STATUS = "info";
      },
      312: function _(e, t, r) {
        "use strict";

        var o = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.store = void 0;

        var i = r(467),
            n = o(r(529)),
            c = _interopRequireWildcard(r(535)),
            u = _interopRequireWildcard(r(954));

        function _getRequireWildcardCache(e) {
          if ("function" != typeof WeakMap) return null;
          var t = new WeakMap(),
              r = new WeakMap();
          return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
            return e ? r : t;
          })(e);
        }

        function _interopRequireWildcard(e, t) {
          if (!t && e && e.__esModule) return e;
          if (null === e || "object" != typeof e && "function" != typeof e) return {
            default: e
          };

          var r = _getRequireWildcardCache(t);

          if (r && r.has(e)) return r.get(e);
          var o = {},
              i = Object.defineProperty && Object.getOwnPropertyDescriptor;

          for (var n in e) {
            if ("default" !== n && Object.prototype.hasOwnProperty.call(e, n)) {
              var c = i ? Object.getOwnPropertyDescriptor(e, n) : null;
              c && (c.get || c.set) ? Object.defineProperty(o, n, c) : o[n] = e[n];
            }
          }

          return o.default = e, r && r.set(e, o), o;
        }

        var s = (0, i.createReduxStore)("core/notices", {
          reducer: n.default,
          actions: c,
          selectors: u
        });
        t.store = s, (0, i.register)(s);
      },
      529: function _(e, t, r) {
        "use strict";

        var o = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var i = r(793);
        var n = (0, o(r(419)).default)("context")(function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
              t = arguments.length > 1 ? arguments[1] : void 0;

          switch (t.type) {
            case "CREATE_NOTICE":
              return [].concat(_toConsumableArray((0, i.reject)(e, {
                id: t.notice.id
              })), [t.notice]);

            case "REMOVE_NOTICE":
              return (0, i.reject)(e, {
                id: t.id
              });
          }

          return e;
        });
        var c = n;
        t.default = c;
      },
      954: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getNotices = function getNotices(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : o.DEFAULT_CONTEXT;
          return e[t] || i;
        };
        var o = r(987);
        var i = [];
      },
      419: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.onSubKey = t.default = void 0;

        var onSubKey = function onSubKey(e) {
          return function (t) {
            return function () {
              var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                  o = arguments.length > 1 ? arguments[1] : void 0;
              var i = o[e];
              if (void 0 === i) return r;
              var n = t(r[i], o);
              return n === r[i] ? r : _objectSpread(_objectSpread({}, r), {}, _defineProperty({}, i, n));
            };
          };
        };

        t.onSubKey = onSubKey;
        var r = onSubKey;
        t.default = r;
      },
      467: function _(e) {
        "use strict";

        e.exports = require("@wordpress/data");
      },
      793: function _(e) {
        "use strict";

        e.exports = require("lodash");
      }
    },
        t = {};

    function __webpack_require__(r) {
      var o = t[r];
      if (void 0 !== o) return o.exports;
      var i = t[r] = {
        exports: {}
      };
      return e[r](i, i.exports, __webpack_require__), i.exports;
    }

    var r = {};
    return function () {
      "use strict";

      var e = r;
      Object.defineProperty(e, "__esModule", {
        value: !0
      }), Object.defineProperty(e, "store", {
        enumerable: !0,
        get: function get() {
          return t.store;
        }
      });

      var t = __webpack_require__(312);
    }(), r;
  }();
});